import IconButton from "@mui/material/IconButton";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import { Box } from "@mui/system";
import Avatar from "@mui/material/Avatar";
import { useRef, useState } from "react";
import CancelIcon from "@mui/icons-material/Cancel";
function BAImageUpload(props) {
  const { onChange, value } = props;
  const [selectedFile, setSelectedFile] = useState("");
  const [fileUrl, setFileUrl] = useState(value ?? "");

  const inputRef = useRef();

  let uploadImg = async (e) => {
    const file = e.target.files[0];
    const base64 = await convertBase64(file);
    setFileUrl(base64);
    onChange(base64);
    setSelectedFile(file);
    // console.log(base64);
  };
  let convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (err) => {
        reject(err);
      };
    });
  };

  let closeFile = () => {
    setFileUrl("");
    setSelectedFile({});
  };

  return (
    <>
      <Box>
        {!fileUrl ? (
          <IconButton
            color="primary"
            aria-label="upload picture"
            component="label"
          >
            <input
              ref={inputRef}
              hidden
              value={fileUrl}
              onChange={(e) => uploadImg(e)}
              accept="image/*"
              type="file"
            />
            <PhotoCamera />
          </IconButton>
        ) : (
          <IconButton onClick={closeFile} color="primary">
            <CancelIcon />
          </IconButton>
        )}

        <Avatar
          alt={selectedFile.fileName}
          src={fileUrl}
          sx={{ width: 56, height: 56 }}
        />
      </Box>
    </>
  );
}
export default BAImageUpload;
